import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, ArrowLeft } from 'lucide-react';

export const EmptyCart = () => (
  <main className="pt-20 min-h-screen flex items-center justify-center" data-testid="checkout-empty">
    <div className="text-center">
      <ShoppingBag className="w-16 h-16 text-zinc-700 mx-auto mb-4" />
      <h2 className="text-white text-2xl mb-2" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
        Your cart is empty
      </h2>
      <p className="text-zinc-500 mb-6">Add some products before checking out</p>
      <Link to="/shop" className="btn-ninja inline-flex items-center gap-2">
        <ArrowLeft className="w-4 h-4" /> Continue Shopping
      </Link>
    </div>
  </main>
);
